import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const QUINTS_API_URLS_ROUTE_NAME = Symbol('quints-api-urls');
export const TRANSLATION_GROUPS_OF_QUINTS_API = Symbol('quints-api');

export const QUINTS_API_URLS_QUERY_KEY = 'quints-api.list';
export const QUINTS_API_URLS_API_URL = 'admin/profile/api_tokens';

export const QUINTS_API_TOKEN_REFRESH_MUTATION_KEY = 'quints-api.refresh';
export const QUINTS_API_TOKEN_REFRESH_API_URL = 'admin/api_tokens_refresh';

export const QUINTS_API_URLS_PERMISSIONS = {
  SHOW: new Permission(
    PermissionsList.admin.PROFILE_API_TOKENS,
  ),
  EDIT: new Permission(
    PermissionsList.admin.PROFILE_EDIT,
  ),
};
